/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Cancellation status for a booking
 * @export
 * @interface BookingCancellationResponse
 */
export interface BookingCancellationResponse {
    /**
     * 
     * @type {number}
     * @memberof BookingCancellationResponse
     */
    id: number;
    /**
     * 
     * @type {number}
     * @memberof BookingCancellationResponse
     */
    bookingId?: number | null;
    /**
     * 
     * @type {string}
     * @memberof BookingCancellationResponse
     */
    hotelStayId: string | null;
    /**
     * 
     * @type {string}
     * @memberof BookingCancellationResponse
     */
    userId: string;
    /**
     * 
     * @type {string}
     * @memberof BookingCancellationResponse
     */
    confirmationNumber?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BookingCancellationResponse
     */
    cancellationNumber?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BookingCancellationResponse
     */
    chainName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BookingCancellationResponse
     */
    rateSource?: BookingCancellationResponseRateSourceEnum | null;
    /**
     * 
     * @type {string}
     * @memberof BookingCancellationResponse
     */
    initiatedBy?: BookingCancellationResponseInitiatedByEnum | null;
    /**
     * 
     * @type {string}
     * @memberof BookingCancellationResponse
     */
    cancellationStatus: BookingCancellationResponseCancellationStatusEnum;
    /**
     * 
     * @type {number}
     * @memberof BookingCancellationResponse
     */
    retriesCounter: number;
    /**
     * 
     * @type {number}
     * @memberof BookingCancellationResponse
     */
    vervotechPropertyId?: number | null;
    /**
     * 
     * @type {Date}
     * @memberof BookingCancellationResponse
     */
    checkinDate?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof BookingCancellationResponse
     */
    firstName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof BookingCancellationResponse
     */
    lastName?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof BookingCancellationResponse
     */
    inProgressAt?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof BookingCancellationResponse
     */
    completedAt?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof BookingCancellationResponse
     */
    canceledAt?: Date | null;
    /**
     * 
     * @type {Date}
     * @memberof BookingCancellationResponse
     */
    createdAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof BookingCancellationResponse
     */
    updatedAt: Date;
}


/**
 * @export
 */
export const BookingCancellationResponseRateSourceEnum = {
    Travelport: 'travelport',
    Direct: 'direct',
    Liteapi: 'liteapi',
    Expedia: 'expedia'
} as const;
export type BookingCancellationResponseRateSourceEnum = typeof BookingCancellationResponseRateSourceEnum[keyof typeof BookingCancellationResponseRateSourceEnum];

/**
 * @export
 */
export const BookingCancellationResponseInitiatedByEnum = {
    UserRequest: 'user_request',
    AutoSave: 'auto_save'
} as const;
export type BookingCancellationResponseInitiatedByEnum = typeof BookingCancellationResponseInitiatedByEnum[keyof typeof BookingCancellationResponseInitiatedByEnum];

/**
 * @export
 */
export const BookingCancellationResponseCancellationStatusEnum = {
    Pending: 'pending',
    Success: 'success',
    Failure: 'failure',
    FailureExhausted: 'failure_exhausted',
    ReservationNotFound: 'reservation_not_found',
    ReservationIneligible: 'reservation_ineligible',
    NotSupported: 'not_supported'
} as const;
export type BookingCancellationResponseCancellationStatusEnum = typeof BookingCancellationResponseCancellationStatusEnum[keyof typeof BookingCancellationResponseCancellationStatusEnum];


/**
 * Check if a given object implements the BookingCancellationResponse interface.
 */
export function instanceOfBookingCancellationResponse(value: object): value is BookingCancellationResponse {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('hotelStayId' in value) || value['hotelStayId'] === undefined) return false;
    if (!('userId' in value) || value['userId'] === undefined) return false;
    if (!('cancellationStatus' in value) || value['cancellationStatus'] === undefined) return false;
    if (!('retriesCounter' in value) || value['retriesCounter'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('updatedAt' in value) || value['updatedAt'] === undefined) return false;
    return true;
}

export function BookingCancellationResponseFromJSON(json: any): BookingCancellationResponse {
    return BookingCancellationResponseFromJSONTyped(json, false);
}

export function BookingCancellationResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): BookingCancellationResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'bookingId': json['booking_id'] == null ? undefined : json['booking_id'],
        'hotelStayId': json['hotel_stay_id'],
        'userId': json['user_id'],
        'confirmationNumber': json['confirmation_number'] == null ? undefined : json['confirmation_number'],
        'cancellationNumber': json['cancellation_number'] == null ? undefined : json['cancellation_number'],
        'chainName': json['chain_name'] == null ? undefined : json['chain_name'],
        'rateSource': json['rate_source'] == null ? undefined : json['rate_source'],
        'initiatedBy': json['initiated_by'] == null ? undefined : json['initiated_by'],
        'cancellationStatus': json['cancellation_status'],
        'retriesCounter': json['retries_counter'],
        'vervotechPropertyId': json['vervotech_property_id'] == null ? undefined : json['vervotech_property_id'],
        'checkinDate': json['checkin_date'] == null ? undefined : (new Date(json['checkin_date'])),
        'firstName': json['first_name'] == null ? undefined : json['first_name'],
        'lastName': json['last_name'] == null ? undefined : json['last_name'],
        'inProgressAt': json['in_progress_at'] == null ? undefined : (new Date(json['in_progress_at'])),
        'completedAt': json['completed_at'] == null ? undefined : (new Date(json['completed_at'])),
        'canceledAt': json['canceled_at'] == null ? undefined : (new Date(json['canceled_at'])),
        'createdAt': (new Date(json['created_at'])),
        'updatedAt': (new Date(json['updated_at'])),
    };
}

export function BookingCancellationResponseToJSON(json: any): BookingCancellationResponse {
    return BookingCancellationResponseToJSONTyped(json, false);
}

export function BookingCancellationResponseToJSONTyped(value?: BookingCancellationResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'booking_id': value['bookingId'],
        'hotel_stay_id': value['hotelStayId'],
        'user_id': value['userId'],
        'confirmation_number': value['confirmationNumber'],
        'cancellation_number': value['cancellationNumber'],
        'chain_name': value['chainName'],
        'rate_source': value['rateSource'],
        'initiated_by': value['initiatedBy'],
        'cancellation_status': value['cancellationStatus'],
        'retries_counter': value['retriesCounter'],
        'vervotech_property_id': value['vervotechPropertyId'],
        'checkin_date': value['checkinDate'] == null ? value['checkinDate'] : value['checkinDate'].toISOString().substring(0,10),
        'first_name': value['firstName'],
        'last_name': value['lastName'],
        'in_progress_at': value['inProgressAt'] == null ? value['inProgressAt'] : value['inProgressAt'].toISOString(),
        'completed_at': value['completedAt'] == null ? value['completedAt'] : value['completedAt'].toISOString(),
        'canceled_at': value['canceledAt'] == null ? value['canceledAt'] : value['canceledAt'].toISOString(),
        'created_at': value['createdAt'].toISOString(),
        'updated_at': value['updatedAt'].toISOString(),
    };
}

